import { render, staticRenderFns } from "./faultmanagement.vue?vue&type=template&id=5b27e6a1&scoped=true"
import script from "./faultmanagement.vue?vue&type=script&lang=js"
export * from "./faultmanagement.vue?vue&type=script&lang=js"
import style0 from "./faultmanagement.vue?vue&type=style&index=0&id=5b27e6a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b27e6a1",
  null
  
)

export default component.exports